import { ChevronRightIcon, Globe } from 'lucide-react';
import { StatusTag } from '../../shared/table/StatusTag';
interface EventCardProps {
  name: string;
  date: string;
  time: string;
  status: string | null;
  isDraft: boolean;
}
export function EventCard({
  name,
  date,
  time,
  status,
  isDraft
}: EventCardProps) {
  return <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors">
      <div>
        <h3 className="font-medium text-gray-900 mb-1">{name}</h3>
        <p className="text-sm text-gray-600">
          {date} • {time}
        </p>
      </div>
      <div className="flex items-center gap-3">
        {status && (
          <div className="flex items-center gap-2">
            {status === 'Shared' && <Globe className="w-4 h-4 text-blue-600" />}
            <StatusTag label={status as string} variant="info" />
          </div>
        )}
        {isDraft && <StatusTag label="Draft" variant="default" />}
        <ChevronRightIcon className="w-5 h-5 text-gray-400" />
      </div>
    </div>;
}